module.exports = __webpack_public_path__ + "static/media/dina_card.2f8adb1b.png";